import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='errorDelegate' subtitle='PrimerHeadlessErrorableDelegate' mdxType="Item">
Error delegate will be triggered every time an error is thrown in the process.
      <pre><code parentName="pre" {...{
          "className": "language-swift"
        }}>{`  func didReceiveError(error: PrimerError)
`}</code></pre>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      